import { Logger } from "../logger/logger";

export type PerlBool = '0' | '1';

// e.g. 'CH' | 'DE'
export type Territory = string;
export type Domain = 'Fogg' | 'Retail';

export enum Query {
    StringValue = 'atv.wps#QueryStringValue',
    ListValue = 'atv.wps#QueryListValue'
}
export interface QueryStringValue {
    __type: Query.StringValue;
    value: string;
}
export interface QueryListValue {
    __type: Query.ListValue;
    value: string[];
}
export interface Parameters {
    [queryParam: string]: QueryStringValue | QueryListValue;
}

export interface QueryParameters {
    [key: string]: string[];
}

export interface RequestContext {
    domain: Domain;
    isInternal: PerlBool;
    requestID: string; // e.g. '61SMZFFAVAMGCXM7PCJD'
    sessionID: string; // e.g. '260-0254514-1436644'
    customerID: string;
    marketplaceID: string; // e.g. 'A3K6Y4MI8GDYMT'
    customerIPAddress: string;
    locale: string; // e.g. en_US or de_DE
    osLocale: string;
    currentTerritory: Territory;
    recordTerritory: Territory;
    originalURI: string;
    path: string;
    weblabOverrides: {
        [weblab: string]: string;
    };
    queryParameters: QueryParameters;
    userAgent: string;
    trafficPolicies: string;
    appName: string;
    deviceID: string;
    geoToken: string;
    identityContext?: string;
    contingencies?: {
        isTesting: PerlBool,
        values: {
            [name: string]: number;
        }
    };
    isTest?: PerlBool;
}

export interface RenderContext {
    isRTL: boolean;
};

export interface InitialArgs {
    context: RequestContext;
    render?: RenderContext;
    [param: string]: any;
}

export interface Args extends InitialArgs {
    logger: Logger;
}
